import { AvailableDate } from './types';

export const hasBookableDates = (availableDays: AvailableDate[]) => {
  const hasAvailableDays = availableDays.length > 0;
  if (!hasAvailableDays) {
    return false;
  }
  return availableDays.some((availableDay) => availableDay.isAvailable);
};
